<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <span class="text-h5 ">
          Manage / <span class="primary--text">Brands</span>
        </span>
      </template>
      <template v-slot:right>
        <span
          class="subtitle-1 grey--text font-weight-light d-flex"
          style="align-items: flex-end;"
          v-if="$store.getters.isUserAdmin"
        >
          <v-btn link outlined :to="{ name: 'BrandCreate' }" color="primary">
            <v-icon left>mdi-plus</v-icon> New brand
          </v-btn>
        </span>
      </template>
    </TopHeader>

    <v-row>
      <v-col class="mt-6 pb-0">
        <v-data-table
          fixed-header
          :height="$vuetify.breakpoint.height - 258"
          :loading="loading"
          class="pos-relative"
          :search="search"
          v-model="selected"
          :headers="headers"
          :items="brands"
          :server-items-length="totalBrands"
          :options.sync="paginate"
          item-key="id"
          show-select
          @click:row="openBrand"
          :footer-props="{ itemsPerPageOptions: [20, 50, 100] }"
        >
          <template v-slot:top>
            <v-row>
              <v-col class="d-flex justify-space-between pt-0 pb- px-10">
                <v-text-field
                  :disabled="loading"
                  clearable
                  @click:clear="search = ''"
                  v-model="search"
                  @keyup.enter.native="handleSearchBrands"
                  style="max-width:300px;"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Search for a brand..."
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.image="{ item }">
            <v-img
              :src="getImgBrand(item)"
              contain
              width="50"
              height="50"
              class="rounded-md ma-2"
            ></v-img>
          </template>
          <template v-slot:item.validated_percent="{ item }">
            <v-chip color="primary" v-if="item.validated_percent !== null">
              {{ item.validated_percent }} %
            </v-chip>
            <v-chip color="blue-grey lighten-4" class="px-5" v-else>
              -
            </v-chip>
          </template>

          <template v-slot:item.last_edit_request.status="{ item }">
            <span v-if="item['last_edit_request.verified_at'] === null">{{
              item["last_edit_request.status"]
            }}</span>
          </template>
          <template v-slot:item.validated="{ item }">
            <v-chip :color="item.validated ? 'success' : 'warning'">{{
              item.validated ? "Yes" : "No"
            }}</v-chip>
          </template>
          <template v-slot:item.discontinued="{ item }">
            <v-chip :color="item.discontinued ? 'warning' : 'success'">{{
              item.discontinued ? "Yes" : "No"
            }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn small text color="accent" @click="openBrand(item)">
              <v-icon left>mdi-eye</v-icon> view
            </v-btn>
          </template>
          <template v-slot:footer>
            <div class="custom-footer-corner">
              <v-menu top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="grey--text">Actions </span>
                  <v-btn
                    class="ml-4"
                    text
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ selected.length }} brands selected
                    <v-icon right> mdi-menu-up</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <!--                  <v-list-item-->
                  <!--                    :disabled="!hasSelectedBrands"-->
                  <!--                    @click="askForDeletion"-->
                  <!--                  >-->
                  <!--                    <v-list-item-icon>-->
                  <!--                      <v-icon>mdi-delete-alert</v-icon>-->
                  <!--                    </v-list-item-icon>-->
                  <!--                    <v-list-item-title>Ask for deletion</v-list-item-title>-->
                  <!--                  </v-list-item>-->
                  <v-list-item
                    :disabled="!hasSelectedBrands"
                    @click="exportBrands"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-table-arrow-down</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Export</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import xlsx from "json-as-xlsx"
import { BrandService } from "@/services"
import { debounce } from "lodash"
import TopHeader from "@/components/base/TopHeader.vue"

export default {
  components: {
    TopHeader
  },
  data() {
    return {
      loading: true,
      search: "",
      paginate: {},
      totalBrands: 0,
      brands: [],
      selected: [],
      headers: [
        {
          value: "validated_percent",
          sortable: true,
          align: "center",
          text: "Validated percentage"
        },
        {
          value: "image",
          sortable: false,
          align: "start",
          text: "Image"
        },
        {
          value: "name",
          sortable: true,
          align: "start",
          text: "Name"
        },
        {
          value: "product_group",
          sortable: true,
          align: "start",
          text: "Product Group"
        },
        {
          value: "created_at",
          sortable: true,
          align: "start",
          text: "Created"
        },
        {
          value: "updated_at",
          sortable: true,
          align: "start",
          text: "Updated"
        },
        {
          value: "last_edit_request.status",
          sortable: true,
          align: "center",
          text: "Status"
        },
        {
          value: "latest_validator",
          sortable: false,
          align: "start",
          text: "Latest validator"
        }
      ]
    }
  },
  mounted() {
    this.$watch(
      "$store.state.brandsFilters",
      (vn, vo) => {
        this.paginate.page = 1
        this.handleSearchBrands()
      },
      { deep: true }
    )
    this.$nextTick(() => {
      this.handleSearchBrands()
    })
  },
  computed: {
    hasSelectedBrands() {
      return this.selected.length > 0
    }
  },
  watch: {
    search(vn, vo) {
      if (this.paginate.page > 1) this.paginate.page = 1
      if (this.search == "") {
        this.debounceSearch()
      }
    },
    paginate: {
      deep: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          if (oldValue.page) {
            this.handleSearchBrands()
          }
        })
      }
    }
  },
  methods: {
    handleSearchBrands() {
      let additionalFilters = {}
      const filters = this.$store.state.brandsFilters
      Object.keys(filters).map(k => {
        let v = filters[k]
        if (v !== null && v !== "")
          additionalFilters[k] = typeof v == "object" ? JSON.stringify(v) : v
      })
      this.getBrands(additionalFilters)
    },
    getBrandName(brand_id) {
      const brand = this.$store.state.brands.find(b => brand_id == b.id)
      if (brand) return brand.name

      return "-"
    },
    debounceSearch: debounce(function() {
      this.handleSearchBrands()
    }, 1000),
    downloadFile(json) {
      var columns = this.headers.map(h => ({ label: h.text, value: h.value }))

      var settings = {
        sheetName: "Sheet1",
        fileName: "perfumist-brands"
      }
      xlsx(columns, json, settings)
    },
    getBrands(additionalFilters = {}) {
      const $ = this
      $.loading = true

      const filters = Object.entries(additionalFilters)
        .map(([k, v]) => `${k}=${v}`)
        .join("&")

      const orders = $.paginate.sortDesc[0]
        ? "-" + this.paginate.sortBy[0]
        : this.paginate.sortBy[0]

      const paginate = {
        page: this.paginate.page,
        page_size: this.paginate.itemsPerPage
      }

      BrandService.list($, this.search, filters, orders, paginate)
        .then(r => {
          $.brands = r.results
          $.totalBrands = r.count
        })
        .finally(() => {
          $.loading = false
        })
    },
    getImgBrand(item) {
      return item["image_url"]
        ? item["image_url"]
        : "@/assets/logo_black_no_text.png"
    },
    openBrand(curr) {
      this.$router.push({ name: "Brand", params: { brand: curr.id } })
      this.$store.commit("setGlobalBrandWithId", curr.id)
    },
    exportBrands() {
      this.downloadFile(this.selected)
      this.$store.commit("success", "Selected items exported !")
    }
  }
}
</script>

<style lang="scss">
.v-data-table__wrapper tr {
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
.custom-footer-corner {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 10px 12px;
}
.pos-relative {
  position: relative;
}
</style>
